/* EMETTE — filter the product gallery by the selected color.
   Media alt text carries the color name ("Statement Set Navy").
   - thumbnail layouts: only the thumbnail rail is filtered; the main viewer
     always shows exactly ONE slide (instant swap via setActiveMedia).
   - stacked layout (and mobile slider): the slides themselves are filtered. */
(function () {
  'use strict';

  function getSelectedColor(scope) {
    var picker = scope.querySelector('variant-selects');
    if (!picker) return null;
    var fieldsets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && /color|culoare/i.test(legend.textContent)) {
        var checked = fieldsets[i].querySelector('input:checked');
        if (checked) return checked.value;
      }
    }
    var selects = picker.querySelectorAll('.product-form__input--dropdown');
    for (var j = 0; j < selects.length; j++) {
      var label = selects[j].querySelector('label');
      if (label && /color|culoare/i.test(label.textContent)) {
        var sel = selects[j].querySelector('select');
        if (sel) return sel.value;
      }
    }
    return null;
  }

  function altOf(el) {
    var img = el.querySelector('img');
    return (img && img.alt ? img.alt : '').toLowerCase();
  }

  function filterGallery(scope) {
    var color = getSelectedColor(scope);
    if (!color) return;
    var needle = color.trim().toLowerCase();

    scope.querySelectorAll('media-gallery').forEach(function (gallery) {
      var layout = (gallery.getAttribute('data-desktop-layout') || '');
      var isThumbLayout = layout.indexOf('thumbnail') !== -1
        && window.matchMedia('(min-width: 750px)').matches;

      var slides = [].slice.call(gallery.querySelectorAll('li[data-media-id]'));
      var thumbs = [].slice.call(gallery.querySelectorAll('.thumbnail-list__item'));
      if (!slides.length) return;

      var matches = slides.filter(function (s) { return altOf(s).indexOf(needle) !== -1; }).length;

      if (isThumbLayout) {
        /* main viewer: leave Dawn's is-active logic alone (one slide at a time) */
        slides.forEach(function (s) { s.style.display = ''; s.classList.remove('emette-media-hidden'); });
        thumbs.forEach(function (th) {
          var show = matches === 0 || altOf(th).indexOf(needle) !== -1;
          th.style.display = show ? '' : 'none';
        });
        /* if the active frame is another color, jump instantly to the first match */
        var active = gallery.querySelector('li[data-media-id].is-active') || slides[0];
        if (matches > 0 && altOf(active).indexOf(needle) === -1) {
          var target = null;
          for (var i = 0; i < thumbs.length; i++) {
            if (thumbs[i].style.display !== 'none' && altOf(thumbs[i]).indexOf(needle) !== -1) {
              target = thumbs[i].getAttribute('data-target');
              break;
            }
          }
          if (!target) {
            var firstSlide = slides.filter(function (s) { return altOf(s).indexOf(needle) !== -1; })[0];
            if (firstSlide) target = firstSlide.getAttribute('data-media-id');
          }
          if (target && gallery.setActiveMedia) {
            try { gallery.setActiveMedia(target, true); } catch (e) { /* noop */ }
          }
        }
      } else {
        /* stacked / mobile: filter the slides themselves */
        slides.forEach(function (s) {
          var show = matches === 0 || altOf(s).indexOf(needle) !== -1;
          s.style.display = show ? '' : 'none';
          s.classList.toggle('emette-media-hidden', !show);
        });
        thumbs.forEach(function (th) {
          var show = matches === 0 || altOf(th).indexOf(needle) !== -1;
          th.style.display = show ? '' : 'none';
        });
        var viewer = gallery.querySelector('[id^="GalleryViewer"], .product__media-list');
        if (viewer && typeof viewer.scrollTo === 'function') {
          viewer.scrollTo({ left: 0, top: 0 });
        }
      }
    });
  }

  function init() {
    var section = document.querySelector('section[id^="MainProduct"], .product');
    var scope = section || document;
    if (!document.querySelector('media-gallery')) return;
    filterGallery(scope);
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) {
        setTimeout(function () { filterGallery(scope); }, 60);
      }
    });
    window.addEventListener('resize', function () { filterGallery(scope); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
